export const siteCategories = [
  { id: "all", name: "全部", slug: "all", icon: "ri-movie-line", description: "浏览全部影视资源" },
  { id: "movie", name: "电影", slug: "movie", icon: "ri-film-line", description: "高清电影在线观看" },
  { id: "tv", name: "电视剧", slug: "tv", icon: "ri-tv-line", description: "热门电视剧全集" },
  { id: "variety", name: "综艺", slug: "variety", icon: "ri-live-line", description: "热门综艺节目" },
  { id: "anime", name: "动漫", slug: "anime", icon: "ri-ghost-line", description: "热门动漫番剧" },
  { id: "documentary", name: "纪录片", slug: "documentary", icon: "ri-earth-line", description: "精彩纪录片" },
  { id: "short", name: "短视频", slug: "short", icon: "ri-vidicon-line", description: "精彩短视频合集" },
  { id: "kids", name: "少儿", slug: "kids", icon: "ri-emotion-laugh-line", description: "少儿动画节目" },
];

export const brandNames = ["香蕉视频", "西瓜视频", "蜜桃视频", "樱桃视频", "芒果视频", "蓝莓视频", "草莓视频", "柠檬视频", "葡萄视频", "荔枝视频"];